import React from "react";
import AppointmentListItem from "./AppointmentListItem";

const AppointmentList = ({
  appointments,
  checkedItems,
  onItemCheckChange,
  allSelected,
  onToggleAll,
}) => {
  return (
    <div className="table-responsive" style={{ maxHeight: "65vh", overflowY: "auto" }}>
      <table className="table align-middle mb-0">
        <thead className="table-light position-sticky top-0" style={{ zIndex: 1 }}>
          <tr>
            <th scope="col" style={{ width: "50px" }}>
              <input
                type="checkbox"
                className="form-check-input"
                checked={allSelected}
                onChange={onToggleAll}
              />
            </th>
            <th scope="col" style={{ width: "160px" }}>Time</th>
            <th scope="col">Appointment Details</th>
            <th scope="col" style={{ width: "140px" }} className="text-end">
              Status / Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {appointments.map((appt) => (
            <AppointmentListItem
              key={appt.id}
              appt={appt}
              isSelected={checkedItems.includes(appt.id)}
              onCheckChange={onItemCheckChange}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AppointmentList;
